import 'whatwg-fetch';
import queryString from 'query-string';
import jwtConfig from '@iso/config/jwt.config';
import history from '@iso/lib/helpers/history';
import tokenService from '@iso/lib/tokenService';
import { LOCAL_STORAGE_LABELS } from '@iso/enums';

/**
 * API request module
 *
 * @param {*} endpoint
 * @param {string} [method='GET']
 * @param {*} [data={}]
 * @param {boolean} [isToken=false]
 * @returns
 */

// TODO: use config object as function parameter
const request = async (
  endpoint,
  method = 'GET',
  data = {},
  isToken = true,
  twoFACode,
  isFormData = false,
  isOutSideApi = false,
  isResponseTypeBlob = false,
  signal = null
) => {
  return new Promise((resolve, reject) => {
    let qs = '';
    let body;

    if (['GET'].indexOf(method) > -1) {
      if (data && Object.keys(data))
        qs = `?${queryString.stringify(data, { arrayFormat: 'bracket' })}`;
    } else {
      body = isFormData ? data : JSON.stringify(data);
    }

    const requestUrl = isOutSideApi
      ? endpoint
      : `${jwtConfig.apiUrl}${endpoint}${qs}`;
    const options = {
      method,
      headers: {},
      body
    };

    if (!isFormData) {
      options.headers['Content-Type'] = 'application/json';
    }

    if (isToken) {
      options.headers.Authorization = `Bearer ${tokenService.getToken()}`;
    }

    if (twoFACode) {
      options.headers['2fa-auth'] = twoFACode;
    }

    if (signal) {
      options.signal = signal;
    }

    fetch(requestUrl, options)
      .then((result) => {
        if (result.status >= 200 && result.status < 300) {
          if (result.status === 204) {
            return resolve();
          }
          return resolve(isResponseTypeBlob ? result.blob() : result.json());
        }
        // Check response status if 401 then refresh token
        if (result.status === 401) {
          const refreshApi = localStorage.getItem(
            LOCAL_STORAGE_LABELS.REFRESH_API
          );

          if (!refreshApi) {
            localStorage.setItem(LOCAL_STORAGE_LABELS.REFRESH_API, '1');
            options.method = 'POST';
            const refreshToken = tokenService.getRefreshToken();
            if (!refreshToken) {
              localStorage.clear();
              history.push('/');
              window.location.reload();
            }
            options.body = JSON.stringify({ refresh: refreshToken });
            fetch(`${jwtConfig.apiUrl}/token/refresh/`, options)
              .then(async (res) => {
                // check if refresh token not valid then redirect to login page
                if (res.status === 401) {
                  localStorage.clear();
                  history.push('/');
                } else {
                  let d = await res.json();
                  tokenService.manageToken(d.access);
                }
                window.location.reload();
              })
              .catch((err) => {
                localStorage.clear();
                history.push('/');
                window.location.reload();
              })
              .finally(() => {
                localStorage.removeItem(LOCAL_STORAGE_LABELS.REFRESH_API);
              });
          }
        }
        return result.json().then(reject);
      })
      .catch((err) => reject(err));
  });
};

export default request;

export const downloadRequest = (
  endpoint,
  method = 'GET',
  data = {},
  isToken = true,
  twoFACode,
  isFormData = false,
  isOutSideApi = false,
  isResponseTypeBlob = true
) => {
  return request(
    endpoint,
    method,
    data,
    isToken,
    twoFACode,
    isFormData,
    isOutSideApi,
    isResponseTypeBlob
  );
};
